// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"cc97838c","452":"466bbc43","580":"48047950","599":"0f98203a"}[chunkId] + ".chunk.js";
};